type LabelInput = {
    forHtml: string;
    message: string;
}

const InputLabel: React.FC<LabelInput> = ({ forHtml, message }) => {

    return <label className="mainLabel" htmlFor={forHtml}>{message}</label>

}
export { InputLabel }